module.exports = __webpack_public_path__ + "static/media/viper.d0dc6517.png";